<section id="faq" aria-labelledby="faq-heading" class="border-t border-cp-line">
  <div [class]="inner + ' ' + pad + ' grid grid-cols-1 gap-12 lg:grid-cols-12'">
    <div class="lg:col-span-4">
      <div class="lg:sticky lg:top-24">
        <h2 id="faq-heading" [class]="h2">Frequently Asked Questions</h2>
        <p [class]="lead + ' mt-5 max-w-[32ch]'">Everything you need to know about the platform, pricing, and process.</p>
        <a routerLink="/contact" [class]="textLink + ' mt-6'">
          Contact Us
          <ng-icon name="phosphorArrowRight" size="15" aria-hidden="true" />
        </a>
      </div>
    </div>

    <div class="space-y-14 lg:col-span-8">
      @for (group of groups; track group.title) {
        <div>
          <h3 class="text-[13px] text-cp-subtle">{{ group.title }}</h3>
          <div class="mt-3 border-t border-cp-line">
            @for (item of group.items; track item.question) {
              <details class="group border-b border-cp-line">
                <summary class="flex cursor-pointer list-none items-start justify-between gap-6 py-5 text-left text-[16px] text-cp-ink transition-colors hover:text-cp-muted focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-cp-accent [&::-webkit-details-marker]:hidden">
                  <span>{{ item.question }}</span>
                  <ng-icon name="phosphorPlus" size="16" class="mt-1 shrink-0 text-cp-subtle transition-transform duration-200 group-open:rotate-45" aria-hidden="true" />
                </summary>
                <div [class]="body + ' max-w-[66ch] space-y-4 pb-6'">
                  @for (paragraph of item.answer; track $index) {
                    <p>{{ paragraph }}</p>
                  }
                </div>
              </details>
            }
          </div>
        </div>
      }
    </div>
  </div>
</section>
